import React, { useEffect, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import styles from "./PartialMoreInfoCard.module.css"
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';

export interface IMoreInfo {
    itemID: number,
    detailCardID: number,
    cardHeaderText: string,
    cardDescription: string[],
    buttonLink: string,
    assetLink: string,
    productDetailCardFeatures: any[]
    typeID: number
}

interface PropsType {
    productCard: IMoreInfo,
}


export default function PartialMoreInfoCard(props: PropsType) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])


    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <div className={`${styles.boxContainer}`} style={{ width: props.productCard.typeID == 3 ? "80%" : "100%" }}>
                    <Row>
                        {props.productCard.typeID != 3 ?
                            <Col lg="7" md="12" xs="12" className={`${styles.selectedDetailSection} ${styles.detailContainer}`}>
                                <div className={`${styles.selectedBrandHeading}`} hidden>
                                    <span>Discover </span>
                                </div>
                                {props.productCard.cardHeaderText.length > 0 ?
                                    < div className={`${styles.mainHeading}`}>
                                        <span>{props.productCard.cardHeaderText}</span>
                                    </div>
                                    : null}
                                {props.productCard.cardDescription.map((des) => {
                                    return (
                                        <div>
                                            <p>{des}
                                            </p>
                                        </div>
                                    )
                                })
                                }
                                {props.productCard.productDetailCardFeatures != undefined || null || "" ?
                                    <Row>
                                        {props.productCard.productDetailCardFeatures.map((item, index) => {
                                            return (
                                                <Col key={index} style={{ padding: "0" }} lg="12" md="12" xs="12" className={`${styles.detail} d-flex`}>
                                                    <p> &#9654; {item.feature}</p>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                    : null
                                }
                                {props.productCard.buttonLink.length > 0 ?
                                    <Button className="jkoa-blue-btn" style={{ marginTop: "20px" }}>
                                        <div style={{ padding: "0", margin: "0" }}>checkout</div>
                                    </Button>
                                    : null
                                }

                            </Col>
                            : null
                        }
                        <Col lg={props.productCard.typeID == 3 ? "12" : "5"} md="12" xs="12" style={{ margin: "0", padding: "0" }}>
                            <div className={`${styles.imageContainer}`}>
                                <img className={`${styles.imageTag}`} src={props.productCard.assetLink}
                                    onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />

                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}